//
const chunk = (collection, size) =>
  Array.from({ length: Math.ceil(collection.length / size) }, (value, index) =>
    collection.slice(index * size, (index + 1) * size))

export default chunk
